/** Ignore wrapper slivers and targets hidden by responsive/module settings. */
export function visibleTourTarget(selector?: string): Element | null {
  if (!selector) return null;
  const element = document.querySelector(selector);
  if (!element) return null;
  const style = window.getComputedStyle(element);
  const bounds = element.getBoundingClientRect();
  return style.display !== "none" && style.visibility !== "hidden" && bounds.width >= 24 && bounds.height >= 24 ? element : null;
}
